import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { ArrowLeft, Lock } from 'lucide-react';
import Button from '../../ui/Button';

/** Shown in place of a page that takes a Nursery Manager or Admin seat. */
export function ManagerSeatRequired({ what }: { what: string }) {
  const { t } = useTranslation('nursery', { keyPrefix: 'ManagerSeatRequired' });
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="bg-white border border-neutral-200 rounded-xl p-8 text-center">
        <Lock className="h-10 w-10 text-neutral-300 mx-auto mb-3" />
        <h2 className="text-lg font-semibold text-neutral-800 mb-1">{t('title')}</h2>
        <p className="text-sm text-neutral-500 mb-4">
          <Trans t={t} i18nKey="body" values={{ what }} components={{ b: <span className="font-medium" /> }} />
        </p>
        <Button variant="outline" size="sm" onClick={() => navigate('/nursery')}>
          <ArrowLeft className="h-4 w-4 mr-1" /> {t('back')}
        </Button>
      </div>
    </div>
  );
}

export function SeatLoading() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <div className="h-8 bg-neutral-100 rounded animate-pulse w-64 mb-4" />
      <div className="h-40 bg-neutral-100 rounded animate-pulse" />
    </div>
  );
}
